import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Back from '../../../components/common/Back';
import { fetchPaymentsList } from '../../../redux/slices/admin/paymentsSlice';
import { exportClients } from '../../../redux/slices/admin/clientsSlice';
import PaymentsTable from './PaymentsTable';
import SearchField from '../../../components/common/SearchField';
import iconDownload from '../../../images/icon-download.svg';
import { useNavigate } from 'react-router-dom';

const Payments = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('payments_list');
  const [searchTerm, setSearchTerm] = useState(null);
  const navigate = useNavigate();

  const shouldHideDashboard = localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1";
  if (!shouldHideDashboard) {
    navigate('/admin/users');
  }

  useEffect(() => {
    dispatch(fetchPaymentsList({ page: 1, searchTerm:searchTerm }));
  }, []);

  const handlePageChange = (page) => {
    dispatch(fetchPaymentsList({ page: 1, searchTerm:searchTerm }));
  }

  const handleSearch = (searchTerm, activeTab) => {
    dispatch(fetchPaymentsList({ page: 1, searchTerm:searchTerm }));
  }

  const handleDownloadExcel = (type) => {
    dispatch(exportClients(type));
  };

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Payments</h1>
            <div className="ms-auto">
               <Back />
            </div>
          </header>
          <div className="col">
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'payments_list' ? 'active' : ''}`}
                  type="button"
                  role="tab"
                >
                  Payments List
                </button>
              </li>
            </ul>
          </div>

         <div className="col-12 mt-4">
      <div className="tab-content">
        {shouldHideDashboard && activeTab === 'payments_list' && (
          <div className="tab-pane show active" role="tabpanel">
            <ul className="ul-btns-action" style={{position:'absolute', top:'-85px'}}>
                   <li>
                <a onClick={()=>handleDownloadExcel('paymentsList')}  style={{marginTop:'-5px'}}>
                  <img src={iconDownload} alt="Download" />
                </a>
              </li>
            </ul>
            <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search..." />
            <PaymentsTable handlePageChange={(page) => dispatch(fetchPaymentsList({ page }))}
            />
          </div>
        )}       
      </div>
    </div>
        </div>  
      </div>
    </Layout>
  );
};

export default Payments;